import API from "../Common/Endpoint/serviceConstrants";
import axiosIntegration from "../Common/Axios/axiosIntegration";
export const sessionLogoutApi = async (payload) => {
    const { data = {} } = await axiosIntegration.post(API.sessionLogout, payload);
  return data;
};